export const CLIENT_FORM_MODES = {
  ADD: 'ADD',
  EDIT: 'EDIT',
}
